import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { TimeSubmissionResultDto } from './time-submission-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { GeneralExpenseSubmissionResultDto } from './general-expense-submission-result-dto';
import { MileageExpenseSubmissionResultDto } from './mileage-expense-submission-result-dto';

export class TimeExpenseSubmissionHistoryResultDto {
    @Type(() => TimeSubmissionResultDto)
    timeSubmissionItems: TimeSubmissionResultDto[];

    @Type(() => GeneralExpenseSubmissionResultDto)
    expenseSubmissionItems: GeneralExpenseSubmissionResultDto[];

    @Type(() => MileageExpenseSubmissionResultDto)
    mileageSubmissionItems: MileageExpenseSubmissionResultDto[];

    submissionId: number;
    status: string;

    @Type(() => UserNameDisplayResultDto)
    submittedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    submittedDate: Date;

    @Type(() => Date)
    fromDate: Date;

    @Type(() => Date)
    toDate: Date;

    referenceNumber: string;
    totalAmount: number;
    reimbursableAmount: number;

    @Type(() => UserNameDisplayResultDto)
    verifiedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    verifiedDate: Date;

    @Type(() => UserNameDisplayResultDto)
    approvedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    approvedDate: Date;

    approverComments: string;
    allowApprove: boolean;
    allowDeny: boolean;
    allowRecall: boolean;

    get submittedByDisplayText(): string {
        return Utils.notNullAndDefined(this.submittedBy) ? this.submittedBy.displayName : null;
    }

    @Exclude()
    selectedTab: { name: string; text: string };
}
